<template>
  <div class="common-card projects-list-wrapper">
    <b-modal
      v-model="isUsersModalVisible"
      ok-title="確定"
      ok-only
      title="項目用戶"
      size="lg"
      centered
    >
      <b-table :items="modalUsers" :fields="userFields" striped hover>
        <template #cell(role)="data">
          {{ data.item.roles && data.item.roles.length && data.item.roles[0].name }}
        </template>
        <template #cell(position)="data">
          {{ data.item.position == "undefined" ? "" : data.item.position }}
        </template>
      </b-table>
    </b-modal>
    <modal-filter
      :filter_invoice_id.sync="filter_invoice_id"
      :filter_customer_id.sync="filter_customer_id"
      :filter_project_status_id.sync="filter_project_status_id"
      :projectStatusesOptions="projectStatusesOptions"
      :customerOptions="handleAdminCustomerOptions"
      :invoiceOptions="handleAdminInvoiceOptions"
      @refetch-data="refetchData"
    />
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center mb-1 mb-sm-0">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-file-lines" />
            項目資料
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋"
          />
          <b-button
            variant="primary"
            class="mr-1"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <b-button
            class="mobile-w100"
            :to="{ name: 'project-create' }"
            v-if="ability.can('create', 'projects')"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增項目</b-button
          >
        </div>
      </div>
    </b-card>
    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refProjectListTable"
          class="position-relative"
          :items="fetchProjects"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: project_status_id -->
          <!-- <template #cell(project_status)="data">
            {{ data.item.project_status && data.item.project_status.name }}
          </template> -->

          <!-- Column: period -->
          <template #cell(invoice)="data">
            <template v-if="Array.isArray(data.item.invoices) && data.item.invoices.length">
              <div v-for="(inv, idx) in data.item.invoices" :key="inv.id">
                <b-link
                  :to="{ name: 'invoice-edit', params: { id: inv.id } }"
                  class="text-primary"
                >
                  {{ inv.invoice_number }}
                </b-link>
                <!-- <span v-if="idx < data.item.invoices.length - 1">, </span> -->
              </div>
            </template>
            <!-- <b-link
              v-else-if="data.item.invoice && data.item.invoice.invoice_number"
              :to="{
                name: 'invoice-edit',
                params: { id: data.item.invoice.id }
              }"
              class="text-primary"
            >
              {{ data.item.invoice.invoice_number }}
            </b-link> -->
          </template>

          <!-- Column: period -->
          <template #cell(period)="data">
            {{
              `${data.item.expect_start_date} - ${data.item.expect_end_date}`
            }}
          </template>

          <!-- Column: project_status_id -->
          <template #cell(project_status_id)="data">
            {{
              getProjectStatusName(data.item.project_status_id)
            }}
          </template>

          <!-- Column: payment_method_id -->
          <!-- <template #cell(payment_method_id)="data">
            {{ paymentMethodOptions && paymentMethodOptions.length > 0 && 
            paymentMethodOptions.filter(ele => ele.id == data.item.payment_method_id)[0] }}
          </template> -->

          <!-- Column: manager_id -->
          <template #cell(manager_id)="data">
            {{
              getManagerName(data.item.manager_id)
            }}
          </template>

          <!-- Column: is_completed -->
          <template #cell(is_completed)="data">
            <feather-icon
              v-if="data.item.is_completed"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>

          <!-- Column: created_at -->
          <template #cell(created_at)="data">
            <div class="d-flex">
              {{ getDateTime(data.item.created_at) }}
            </div>
          </template>

          <template #cell(users)="data">
            <div class="d-flex cursor-pointer">
              <span
                @click="showUsersModal(data.item.users)"
                class="user-number"
                >{{ data.item.users && data.item.users.length }}</span
              >
            </div>
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                projectsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <!-- <b-dropdown-item
                v-if="ability.can('read', 'projects')"
                :to="{
                  name: 'project-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item> -->
               <b-dropdown-item
                v-if="ability.can('view_detail', 'projects')"
                :to="{
                  name: 'order-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'projects')"
                :to="{
                  name: 'project-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'projects')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除資料</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useProjectsList from "./useProjectsList";
import projectStoreModule from "../projectStoreModule";
import ModalFilter from "../modal/ModalFilter.vue";

export default {
  components: {
    ModalFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      isUsersModalVisible: false,
      modalUsers: [],
      userFields: [
        { key: "name_cn", label: "姓名" },
        { key: "position", label: "職位" },
        { key: "role", label: "角色" },
      ],
    };
  },
  computed: {
    handleAdminCustomerOptions() {
      if (this.ability.can("admin", "projects")) {
        return this.customerOptions;
      }
      if (!this.projectsList || !this.projectsList.length) {
        return [];
      }
        const referencedCustomerIds = this.projectsList
          .map((item) => item.customer_id)
          .filter((id) => id !== null && id !== undefined);

        // 去重
        const uniqueCustomerIds = [...new Set(referencedCustomerIds)];

        // 從 invoiceOptions 中篩選出被引用的發票
        return this.customerOptions.filter((customer) =>
          uniqueCustomerIds.includes(customer.id)
        );
    },

    handleAdminInvoiceOptions() {
      if (this.ability.can("admin", "projects")) {
        return this.invoiceOptions;
      }

      if (!this.projectsList || !this.projectsList.length) {
        return [];
      }
        // 收集所有 aggregated_summaries 中的 reference_invoice_id
        const referencedInvoiceIds = this.projectsList
          .map((item) => item.invoice_id)
          .filter((id) => id !== null && id !== undefined);

        // 去重
        const uniqueInvoiceIds = [...new Set(referencedInvoiceIds)];

        // 從 invoiceOptions 中篩選出被引用的發票
        return this.invoiceOptions.filter((invoice) =>
          uniqueInvoiceIds.includes(invoice.id)
        );
      // return this.invoiceOptions.filter(ele => ele.id == this.projectsList.invoice_id);
    }
  },
  methods: {
    showUsersModal(users) {
      this.modalUsers = users;
      this.isUsersModalVisible = true;
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("project/deleteProject", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    getProjectStatusName(statusId) {
      if (!statusId || !this.projectStatusesOptions?.length) return '';
      const status = this.projectStatusesOptions.find(ele => ele.id == statusId);
      return status?.name || '';
    },
    getManagerName(managerId) {
      if (!managerId || !this.managerOptions?.length) return '';
      const manager = this.managerOptions.find(ele => ele.id == managerId);
      return manager?.name_cn || '';
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "project";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, projectStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchProjects,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      projectsList,
      refProjectListTable,
      ability,
      refetchData,
      filter_invoice_id,
      filter_project_status_id,
      filter_customer_id,
      projectStatusesOptions,
      invoiceOptions,
      managerOptions,
      customerOptions,
    } = useProjectsList();

    return {
      fetchProjects,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      projectsList,
      refProjectListTable,
      ability,
      refetchData,
      filter_invoice_id,
      filter_project_status_id,
      filter_customer_id,
      projectStatusesOptions,
      invoiceOptions,
      managerOptions,
      customerOptions,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";

.user-number {
  text-decoration: underline;
}
@media (min-width: 540px) {
  .projects-list-wrapper {
    .sticky-column {

      &:nth-child(2) {
        left: 120px;
        width: 70px !important;
        min-width: 70px !important;
        max-width: 70px !important;
      }

      &:nth-child(3) {
        left: 190px;
        width: 120px !important;
        min-width: 120px !important;
        max-width: 120px !important;
      }
    }
  }
}
</style>
    